import React from "react";
import { ArrowRight } from "lucide-react";

const BOTTLES = [
  {
    name: "Iced Tea",
    url: "https://customer-assets.emergentagent.com/job_2c76cf32-2b84-4c50-9f36-10bc5c316a14/artifacts/2qdclh1f_Thai%20Tea%20Bottle.png",
    rotate: "-rotate-3",
    translate: "translate-y-6",
  },
  {
    name: "Iced Green Tea",
    url: "https://customer-assets.emergentagent.com/job_2c76cf32-2b84-4c50-9f36-10bc5c316a14/artifacts/zfrr5a8c_Thai%20Green%20Tea%20Bottle.png",
    rotate: "rotate-1",
    translate: "-translate-y-4",
  },
  {
    name: "Iced Coffee",
    url: "https://customer-assets.emergentagent.com/job_2c76cf32-2b84-4c50-9f36-10bc5c316a14/artifacts/zrgl3jw8_Thai%20Coffee%20Bottle.png",
    rotate: "rotate-3",
    translate: "translate-y-3",
  },
];

export default function Hero({ onShopClick }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden bg-[#FDFBF7] pt-12 pb-24 lg:pt-20 lg:pb-32"
    >
      {/* Botanical backdrop */}
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "url(https://images.pexels.com/photos/15737814/pexels-photo-15737814.jpeg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-6 lg:pr-8">
          <div className="text-xs uppercase tracking-[0.3em] text-[#D96C2B] mb-6">
            Cold-Brewed &middot; Hand-Crafted &middot; 16 oz
          </div>
          <h1 className="font-display text-[#2C4C3B] text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter">
            A sip of
            <span className="block italic text-[#D96C2B]">Thailand</span>
            in every bottle.
          </h1>
          <p className="mt-8 text-lg text-[#4A5D53] max-w-md leading-relaxed">
            Three small-batch beverages, each one steeped slow and finished
            with care. No fillers, no shortcuts — just the cold, creamy soul
            of Thai tea culture.
          </p>

          <div className="mt-10 flex items-center gap-6">
            <button
              data-testid="hero-shop-btn"
              onClick={onShopClick}
              className="group inline-flex items-center gap-3 px-7 py-4 bg-[#D96C2B] text-[#FDFBF7] uppercase tracking-wider text-sm hover:bg-[#B75718] transition-colors"
            >
              Shop the Trio
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </button>
            <a
              data-testid="hero-story-link"
              href="#story"
              className="text-sm uppercase tracking-wider text-[#2C4C3B] underline underline-offset-8 hover:text-[#D96C2B] transition-colors"
            >
              Our Story
            </a>
          </div>

          <div className="mt-12 flex items-center gap-8">
            <div>
              <div className="font-display text-3xl text-[#2C4C3B]">$7</div>
              <div className="text-xs uppercase tracking-widest text-[#4A5D53] mt-1">
                Per bottle
              </div>
            </div>
            <div className="h-12 w-px bg-[#E5DFD3]" />
            <div>
              <div className="font-display text-3xl text-[#2C4C3B]">3</div>
              <div className="text-xs uppercase tracking-widest text-[#4A5D53] mt-1">
                Signature flavors
              </div>
            </div>
            <div className="h-12 w-px bg-[#E5DFD3]" />
            <div>
              <div className="font-display text-3xl text-[#2C4C3B]">16oz</div>
              <div className="text-xs uppercase tracking-widest text-[#4A5D53] mt-1">
                Every pour
              </div>
            </div>
          </div>
        </div>

        {/* Staggered bottles */}
        <div className="lg:col-span-6 relative h-[420px] sm:h-[520px] lg:h-[620px]">
          <div className="absolute inset-0 flex items-end justify-center gap-2 sm:gap-6 lg:gap-10">
            {BOTTLES.map((b, i) => (
              <div
                key={b.name}
                className={`relative transform ${b.rotate} ${b.translate} transition-transform duration-700 hover:translate-y-0 hover:rotate-0`}
                style={{ animation: `floatUp 1.2s ${i * 0.15}s ease-out both` }}
              >
                <img
                  src={b.url}
                  alt={`Thai ${b.name}`}
                  className="h-[340px] sm:h-[440px] lg:h-[560px] w-auto object-contain drop-shadow-[0_25px_30px_rgba(31,41,36,0.25)]"
                />
              </div>
            ))}
          </div>
          <div className="absolute -bottom-2 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#E5DFD3] to-transparent" />
        </div>
      </div>

      <style>{`
        @keyframes floatUp {
          0% { opacity: 0; transform: translateY(40px); }
          100% { opacity: 1; }
        }
      `}</style>
    </section>
  );
}
